export enum GenderType {
  Male = 1,
  Female = 2,
}
